// object-fit polyfill for IE11/Edge
import objectFitImages from '../../node_modules/object-fit-images';

export default function () {
  document.addEventListener("DOMContentLoaded", () => {
    objectFitImages();
  });
}


